import storage from 'utils/storage'
import cloneDeep from 'lodash/cloneDeep'
import objectPath from 'object-path'
import {
  CLEAR_HISTORY_LIST,
  CLEAR_TRADE_STOCKS,
  RESET_TRADE_DOMSCROLLABLE
} from 'store/mutation-types'

export default function persist(store) {
  // 不需要根据用户信息存储
  const NO_USER_PATHS = ['account.identity', 'settings']
  mapStorageToState(store, 'persist-state', NO_USER_PATHS)
  NO_USER_PATHS.forEach(path => {
    store.watch(
      state => {
        return objectPath.get(state, path)
      },
      data => {
        mapStateToStorage(store, 'persist-state', path, data)
      },
      {
        deep: true
      }
    )
  })

  // 需要根据用户信息变化存储
  const USER_PATHS = [
    'stock.tradeStocks',
    'account.tradeToken',
    'trade.domScrollable',
    'historyList.symbols'
  ]
  if (store.getters.uuid) {
    const key = 'persist-' + store.getters.uuid
    mapStorageToState(store, key, USER_PATHS)
  }
  store.watch(
    (state, getters) => getters.uuid,
    uuid => {
      if (uuid) {
        const key = 'persist-' + uuid
        store.commit(CLEAR_HISTORY_LIST)
        store.commit(CLEAR_TRADE_STOCKS)
        store.commit(RESET_TRADE_DOMSCROLLABLE)
        mapStorageToState(store, key, USER_PATHS)
      }
    }
  )
  USER_PATHS.forEach(path => {
    store.watch(
      state => {
        return objectPath.get(state, path)
      },
      data => {
        const uuid = store.state.account.user && store.state.account.user.uuid
        if (uuid) {
          const key = 'persist-' + uuid
          mapStateToStorage(store, key, path, data)
        }
      },
      {
        deep: true
      }
    )
  })
}

/**
 * 映射本地存储信息到state
 * @param {Object} store - vuex store
 * @param {string} key - 存储key
 * @param {string[]} paths - 对象访问路径列表
 */
function mapStorageToState(store, key, paths) {
  const savedState = storage.get(key)
  const deepCloneState = cloneDeep(store.state)
  if (savedState && typeof savedState === 'object') {
    paths.forEach(path => {
      const data = objectPath.get(savedState, path)
      if (data === undefined || data === null) return
      objectPath.set(deepCloneState, path, data)
    })

    store.replaceState(deepCloneState)
  }
}

/**
 * 映射state信息到本地存储
 * @param {Object} store - vuex store
 * @param {string} key - 存储key
 * @param {string} path - 对象访问路径
 * @param {string} data - 存储数据
 */
function mapStateToStorage(store, key, path, data) {
  const savedState = storage.get(key) || {}
  objectPath.set(savedState, path, data)
  storage.set(key, savedState)
}
